import * as runtime from '@/api/runtime'
import {
  BatchBibliographyCollectionImportRequest,
  BatchBibliographyCollectionImportRequestToJSON
} from '@/api/models/batch/BatchBibliographyCollectionImportRequest'

/**
 * 書誌・所蔵データインポート
 */
export class BatchBibliographyCollectionImportApi extends runtime.BaseAPI {
  async import(
    request: BatchBibliographyCollectionImportRequest
  ): Promise<any> {
    const response = await this.requestPost(
      `/batch/bibliography/import`,
      BatchBibliographyCollectionImportRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
